export const ProjectItems=[
    {
        title: 'Tesla Clone',
        preview: './projects-img/teslaclone.webp',
        description: 'A clone of the webpage of Tesla',
        techs: ['ReactJS', 'Redux', 'CSS'],
        repo: 'https://github.com/jcontrerasroberto/tesla-clone',
        demo: null
    },
    {
        title: 'Flappy Bird Clone',
        preview: './projects-img/flappybird.webp',
        description: 'A clone of the popular game Flappy Bird',
        techs: ['Java', 'MySQL'],
        repo: 'https://github.com/jcontrerasroberto/FlappyBirdJava',
        demo: null
    },
    {
        title: 'YouDownloader',
        preview: './projects-img/youdownloader.webp',
        description: 'Electron app to download audio from youtube videos using youtube-dl',
        techs: ['Electron', 'HTML', 'CSS', 'NodeJS', 'JavaScript'],
        repo: 'https://github.com/jcontrerasroberto/youdownloader',
        demo: null
    },
    {
        title: 'Hangman',
        preview: './projects-img/hangman.webp',
        description: 'Hangman game made in python',
        techs: ['Python', 'PyQt5'],
        repo: 'https://github.com/jcontrerasroberto/hangman',
        demo: null
    },
    {
        title: 'Compile And Run',
        preview: './projects-img/compileandrun.webp',
        description: 'Bash script to be more productive',
        techs: ['Bash', 'Linux'],
        repo: 'https://github.com/jcontrerasroberto/CompileAndRun',
        demo: null
    },
    {
        title: 'Tasks App',
        preview: './projects-img/taskapp.webp',
        description: 'A kind of Todo app that uses localStorage',
        techs: ['HTML', 'CSS', 'JavaScript'],
        repo: 'https://github.com/jcontrerasroberto/TasksApp',
        demo: null
    },
    {
        title: 'Netflix Phishing',
        preview: './projects-img/netflix.webp',
        description: 'Informative project to warn about phishing',
        techs: ['HTML', 'CSS', 'PHP', 'MySQL'],
        repo: 'https://github.com/jcontrerasroberto/netflix-phishing',
        demo: null
    },
    {
        title: 'Chess-UI',
        preview: './projects-img/chess-ui.webp',
        description: 'Interface of a chess game coded in Java',
        techs: ['Java'],
        repo: 'https://github.com/jcontrerasroberto/chess-ui',
        demo: null
    },
    {
        title: 'Draw Lines',
        preview: './projects-img/drawlines.webp',
        description: 'Java program to draw lines using the mouse',
        techs: ['JAVA'],
        repo: 'https://github.com/jcontrerasroberto/DrawLines',
        demo: null
    },
    {
        title: 'Meme Generator',
        preview: './projects-img/memegenerator.webp',
        description: 'Simple web page to generate memes',
        techs: ['ReactJS', 'HTML', 'CSS', 'JavaScript'],
        repo: 'https://github.com/jcontrerasroberto/meme-generator',
        demo: null
    },
    {
        title: 'Fifteen Puzzle',
        preview: './projects-img/puzzlenumber.webp',
        description: 'Easy game in java of the famous Fifteen Puzzle',
        techs: ['Java'],
        repo: 'https://github.com/jcontrerasroberto/PuzzleNumbers',
        demo: null
    }

]
